/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown> }} Plan_Add_OnInputs */

const en_plan_add_on = /** @type {(inputs: Plan_Add_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Add a cook session on ${i?.day}`)
};

const de_plan_add_on = /** @type {(inputs: Plan_Add_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kochsession am ${i?.day} hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add a cook session on {day}" |
*
* @param {Plan_Add_OnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_add_on = /** @type {((inputs: Plan_Add_OnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Add_OnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_plan_add_on(inputs)
	return en_plan_add_on(inputs)
});